export const MIN_LANE_WIDTH = 240;
export const MIN_LANE_HEIGHT = 120;
